
















































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  EntityServiceTransaction,
  ServiceTransactionInitState
} from '@/store/service-transaction/service-transaction.types';
import {MemberServiceType} from '@/store/member/member.enum';
import {Helper} from '../../../util/helper';
import BgTheme1 from '@/components/bg-theme-1.vue';
import {LoginInfo} from '@/store/auth/auth.types';
import {AuthEnum} from '@/store/auth/auth.enum';

@Component({
  components: {
    BgTheme1
  }
})
export default class InviteNotificationComponent extends Vue {

  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getServiceTransactionInviteList', {namespace: 'serviceTransaction'}) getServiceTransactionInviteList!: () => Promise<void>;

  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
  public listTransactionInvite = [] as EntityServiceTransaction[];
  public lib: Helper = new Helper();

  async mounted() {
    await this.Loading(true);
    await this.getServiceTransactionInviteList();
    this.listTransactionInvite = this.serviceTransactionInitState.serviceTransactions;
    await this.Loading(false);

  }

  // traServiceType(type: string) {
  //
  //
  //   return type === MemberServiceType.ServiceProvider ? 'ให้บริการ' : 'รับบริการ';
  // }

  traServiceType(service: EntityServiceTransaction) {
    if(service.serviceType === MemberServiceType.ServiceReceiver) {
      if (this.loginInfo.id === service.memberId) {
        return 'ให้บริการ';
      } else {
        return 'รับบริการ';
      }
    }else {
      if (this.loginInfo.id === service.memberId) {
        return 'รับบริการ';
      } else {
        return 'ให้บริการ';
      }
    }
  }

}
